import { render, staticRenderFns } from "./CreateOrUpdateBankDialog.vue?vue&type=template&id=056cd294"
import script from "./CreateOrUpdateBankDialog.vue?vue&type=script&lang=ts"
export * from "./CreateOrUpdateBankDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports